import { forwardRef } from 'react';
import { StyledText } from './styled';

const Text = forwardRef((props, ref) => <StyledText ref={ref} {...props} />);

export default Text;
